<template>
  <div class="lp-child-base basic-result" :style="styles">
    <block-title :target-info="targetInfo" :color-scheme="colorScheme" />
    <block-fortune-result :target-info="targetInfo" :color-scheme="colorScheme" :result-data="resultData" />
    <!-- <block-sns-share :target-info="targetInfo" :color-scheme="colorScheme" :result-share-words="resultShareWords" :result-share-url="resultShareUrl" :lp-id="lpId"/> -->
    <!-- <block-mokuji :target-info="targetInfo" :color-scheme="colorScheme" :result-data="resultData" /> -->
    <!-- <block-lead-menu :target-info="targetInfo" :color-scheme="colorScheme" :subsc-url="subscUrl" /> -->
    <!-- <block-menus v-if="menusList.length" :target-info="targetInfo" :color-scheme="colorScheme" :menu-list="menusList" :ga-event-categ="`LP${this.lpId}basicresult-paid-content-button`" page="basicresult"/> -->
    <!-- <line-campaign-message :target-info="targetInfo" :color-scheme="colorScheme"/> -->
    <!-- <block-banner v-if="showBanner" banner-pos="1" :ga-event-categ="`LP${this.lpId}basicresult-uranaitv-2022unsei-banner`" :lp-id="lpId" campaign="yearluck" /> -->
    <block-about-type :target-info="targetInfo" :color-scheme="colorScheme" :result-data="resultData" />
    <block-uranai-tv-desc
      v-if="previewResultList.length"
      :lp-id="lpId"
      :target-info="targetInfo"
      :color-scheme="colorScheme"
      :preview-result-list="previewResultList"
      :subsc-url="subscUrl"
    />
    <block-about-counselor :target-info="targetInfo" :color-scheme="colorScheme" :lp-id="lpId" page="basicresult" :subsc-url="subscUrl" />
    <block-about-fortune :target-info="targetInfo" :color-scheme="colorScheme" :lp-id="lpId" page="basicresult" :subsc-url="subscUrl" />
    <block-review :target-info="targetInfo" :color-scheme="colorScheme" :review-list="reviewListMod" :lp-id="lpId" page="basicresult" :subsc-url="subscUrl" />
    <!-- <block-lead-subsc :target-info="targetInfo" :color-scheme="colorScheme" :subsc-url="subscUrl" /> -->
    <!-- <block-advice :target-info="targetInfo" :color-scheme="colorScheme" :result-data="resultData" /> -->
    <!-- <block-title2 :target-info="targetInfo" :color-scheme="colorScheme" /> -->
    <!-- <block-fortune-input :target-info="targetInfo" :color-scheme="colorScheme" :action="action" :method="method" :token="token" :lp-id="lpId" pageLabel="basicresult" /> -->
    <!-- <block-faq :color-scheme="colorScheme" :subsc-url="subscUrl" /> -->

    <!-- <block-uranai-tv-short
      :target-info="targetInfo"
      :color-scheme="colorScheme"
      :subsc-url="subscUrl"
      :lp-id="lpId"
      page="basicresult"
    /> -->

    <!-- <block-menus
      :lp-id="lpId"
      v-if="menusList.length"
      :target-info="targetInfo"
      :color-scheme="colorScheme"
      :menu-list="menusList"
      :tab-list="menusTabList"
      :ga-event-categ="`LP${lpId}basicresult-paid-content-button`"
      page="basicresult"
    /> -->

    <!-- <div class="banner-wrap">
      <block-banner
        v-if="showBanner"
        banner-pos="1"
        :ga-event-categ="`LP${lpId}basicresult-LINE-campaign-banner`"
        :lp-id="lpId"
        :campaign="bannerType"
        :target-info="targetInfo"
        :color-scheme="colorScheme"
        :has-caption="true"
      />
    </div> -->

  </div>
</template>

<script>
import BlockTitle from '@/utvStore/components/recommend/lp/blocks/BlockTitle'
import BlockFortuneResult from './blocks/BlockFortuneResult'
import BlockSnsShare from '@/utvStore/components/recommend/lp/blocks/BlockSnsShare'
import BlockMokuji from './blocks/BlockMokuji'
import BlockLeadMenu from './blocks/BlockLeadMenu'
import BlockMenus from '@/utvStore/components/recommend/lp/blocks/BlockMenus'
import BlockAboutType from './blocks/BlockAboutType'
import BlockLeadSubsc from '@/utvStore/components/recommend/lp/blocks/BlockLeadSubsc'
import BlockAdvice from './blocks/BlockAdvice'
import BlockTitle2 from '@/utvStore/components/recommend/lp/blocks/BlockTitle2'
import BlockFortuneInput from './blocks/BlockFortuneInput'
import BlockFaq from '@/utvStore/components/recommend/lp/blocks/BlockFaq'
import BlockBanner from '@/utvStore/components/recommend/lp/blocks/BlockBanner'
import LineCampaignMessage from '@/utvStore/components/recommend/lp/partials/LineCampaignMessage'
import BlockUranaiTvShort from '@/utvStore/components/recommend/lp/blocks/BlockUranaiTvShort'
import BlockUranaiTvDesc from './blocks/BlockUranaiTvDesc'
import BlockAboutCounselor from './blocks/BlockAboutCounselor2'
import BlockAboutFortune from './blocks/BlockAboutFortune2'
import BlockReview from './blocks/BlockReview'

export default {
  name: 'BasicResult',
  components: {
    BlockTitle,
    BlockFortuneResult,
    BlockSnsShare,
    BlockMokuji,
    BlockLeadMenu,
    BlockMenus,
    BlockAboutType,
    BlockLeadSubsc,
    BlockAdvice,
    BlockTitle2,
    BlockFortuneInput,
    BlockFaq,
    BlockBanner,
    LineCampaignMessage,
    BlockUranaiTvShort,
    BlockUranaiTvDesc,
    BlockAboutCounselor,
    BlockAboutFortune,
    BlockReview,
  },
  props: {
    lpId: {
      type: Number,
      default: 1,
    },
    menusList: {
      type: Array,
      default(){
        return []
      }
    },
    menusTabList: {
      type: Array,
      default(){
        return []
      }
    },
    targetInfo: {
      type: Object,
      default(){
        return {}
      }
    },
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
    resultData: Object,
    token: {
      type: String,
      default: '',
    },
    subscUrl: String,
    resultShareWords: {
      type: String,
      default: '',
    },
    bannerType: {
      type: String,
      default: 'LINE',
    },
    previewResultList: {
      type: Array,
      default() { return [] },
    },
    reviewList: {
      type: Array,
      default(){
        return []
      }
    },
  },
  data(){
    return {
      action: `/recommend/lp/${this.lpId}/basic/action`,
      method: 'post',
    }
  },
  computed:{
    resultShareUrl(){
      return !!location.href ? location.href : ''
    },
    styles(){
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
        '--mess-bg': this.colorScheme.messBg,
      }
    },
    showBanner() {
      return true
    },
    reviewListMod() {
      console.log('targetInfo:%O', this.targetInfo)
      return !!this.reviewList && this.reviewList.length > 0 ? this.reviewList : (!!this.targetInfo.reviews ? this.targetInfo.reviews : [])
    },
  },
}</script>

<style scoped lang="scss">
@import "../../../../../../../sass/commons/commonVariables.scss";
$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);
$l_col_mess_bg: var(--mess-bg);

.btn-base {
  width: 100%;
  padding: 20px;
}
.lp-child-base {
  font-family: "ヒラギノ角ゴ ProN W3", "Hiragino Kaku Gothic Pro", "source-han-sans-japanese", -apple-system, BlinkMacSystemFont, sans-serif;
  color: #32373F;
  .line-campaign-message {
    background: #fff;
  }
  .block-banner {
    padding-top: 8px;
    padding-bottom: 40px;
    margin-bottom: 48px;
    background: $l_col_mess_bg;
  }
  /deep/ {
    .block-title2 .block-title2__deco { left: unset; right: 0;}

    .block-fortune-result,
    .block-sns-share,
    .block-title,
    .block-title2,
    .block-fortune-input {
      background: url(/static/img/recommend/lp/ottimo/fotune_bg1.png);
      background-size: 15px 15px;
    }
    .block-review-base {
      padding-bottom: 85px;
      h2 {
        span {
          text-align: left;
          text-indent: -9999px;
          overflow: hidden;
          display: inherit;
          width: 100%;
          background: url(/static/img/recommend/lp/ottimo/header_reviews.png) no-repeat center center;
          background-size: auto 100%;
          height: 1em;
        }
      }
    }
    .block-review-base .block-title,
    .block-about-fortune-base .block-title {
      background: inherit;
      background-size: inherit;
    }
    .block-menu-base {
      padding-bottom: 22px;
      background: $l_col_mess_bg;
      .block-title{
        background: transparent;
      }
    }
  }
  /*
  .block-title,
  .block-sns-share,
  .block-title2 {
    background: #FFEDFA;
  }
   */
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/counselor/ottimo/BasicResult.vue